import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { PageCardPropsType } from 'Type/CMS.type';
import { MixType } from 'Type/Common.type';

import PageCard from './PageCard.component';

/** @namespace PeggysagePwa/Component/PageCard/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    isMobile: state.ConfigReducer.device.isMobile
});

/** @namespace PeggysagePwa/Component/PageCard/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({
    // ...
});

/** @namespace PeggysagePwa/Component/PageCard/Container */
export class PageCardContainer extends PureComponent {
    static propTypes = {
        isMobile: PropTypes.bool.isRequired,
        page: PageCardPropsType.isRequired,
        linkLabel: PropTypes.string,
        isListing: PropTypes.bool,
        isHorizontallyDisplayedOnMobile: PropTypes.bool,
        isHorizontallyDisplayedOnDesktop: PropTypes.bool,
        isLinkVisible: PropTypes.bool,
        mix: MixType
    };

    static defaultProps = {
        linkLabel: '',
        isListing: false,
        isHorizontallyDisplayedOnMobile: false,
        isHorizontallyDisplayedOnDesktop: false,
        isLinkVisible: null,
        mix: {}
    };

    componentDidUpdate(prevProps) {
        const { isMobile } = this.props;
        const { isMobile: prevIsMobile } = prevProps;

        if (isMobile !== prevIsMobile) {
            this.setState({ isHorizontal: this.getHorizontalDisplay() });
        }
    }

    __construct(props) {
        const { page: { page_type, limitation_customer_group_ids = [] }, linkLabel, isLinkVisible } = props;

        // eslint-disable-next-line fp/no-let
        let label;

        if (!linkLabel) {
            switch (page_type) {
            case 'tutorial':
                label = __('Voir le tuto');
                break;
            case 'conseil':
                label = __('Voir le conseil');
                break;
            default:
                label = __('Lire la suite');
            }
        }

        this.state = {
            linkLabel: linkLabel || label,
            isHorizontal: this.getHorizontalDisplay(),
            isLinkVisible: isLinkVisible === true || !this.getHorizontalDisplay(),
            allowedCustomerGroupIds: limitation_customer_group_ids
        };
    }

    getHorizontalDisplay() {
        const { isMobile, isHorizontallyDisplayedOnMobile, isHorizontallyDisplayedOnDesktop } = this.props;

        return (isMobile && isHorizontallyDisplayedOnMobile) || (!isMobile && isHorizontallyDisplayedOnDesktop);
    }

    containerProps() {
        const {
            isMobile, page, isListing, mix
        } = this.props;
        const {
            linkLabel, allowedCustomerGroupIds, isHorizontal, isLinkVisible
        } = this.state;

        return {
            isMobile,
            page,
            isListing,
            mix,
            linkLabel,
            allowedCustomerGroupIds,
            isHorizontal,
            isLinkVisible
        };
    }

    render() {
        return (
            <PageCard
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PageCardContainer);
